<template>
    <div class="changebtn">
      <div
        class="register-btn phone-btn"
        :class="{'phone-btn-active':type=='phone'}"
        @click="changeType('phone')"
      >
        <i></i>
        <span>{{$t('title.w8')}}</span>
      </div>
      <div
        class="register-btn email-btn"
        :class="{'email-btn-active':type=='email'}"
        @click="changeType('email')"
      >
        <i></i>
        <span>{{$t('title.w9')}}</span>
      </div>
    </div>
</template>

<script>
export default {
    props:["type"],
    methods: {
        changeType(newType) {
            this.$emit('update:type', newType)
        }
    },
}
</script>

<style lang="less" scoped>
.changebtn {
  display: flex;
  cursor: pointer;
  width: 250px;
  height: 32px;
  background: rgba(228, 235, 248, 1);
  border-radius: 16px;
  margin: 0 auto 35px;
  .register-btn {
    width: 122px;
    height: 28px;
    margin-top: 2px;
    margin-left: 2px;
    border-radius: 16px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      width: 14px;
      height: 14px;
      display: inline-block;
      margin-right: 8px;
      background: url("../assets/login_icon14x14.png") no-repeat;
      background-size: cover;
    }
    span {
      font-size: 12px;
      font-weight: 500;
      color: #65718a;
    }
  }
  .phone-btn {
    i {
      background-position: 0 -70px;
    }
    span {
      margin-top: -2px;
    }
  }
  .email-btn {
    i {
      background-position: 0 -98px;
    }
  }
  .phone-btn-active {
    background: #fff;
    i {
      background-position: 0 -56px;
    }
    span {
      color: #232325;
    }
  }
  .email-btn-active {
    background: #fff;
    i {
      background-position: 0 -84px;
    }
    span {
      color: #232325;
    }
  }
}
</style>

